import React from 'react';

import Input from 'components/Input';
import { NameForm, SubmitName } from './styles';
import Icon from 'components/Icon';
import { Box } from '../../../utils/style/extendable';
import i18n, { languageDirection } from '../../../i18n';

interface IChangeNameProps {
  loading: boolean;
  userName: string;
  onNameSubmit: (updatedName: string) => void;
}

const ChangeName: React.FC<IChangeNameProps> = ({
  loading,
  userName,
  onNameSubmit,
}) => {
  const nameInput: React.RefObject<HTMLInputElement> = React.createRef();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (nameInput.current) {
      onNameSubmit(nameInput.current.value);
    }
  };
  return (
    <Box style={{ marginTop: '2rem' }}>
      <h6> {i18n.t('personalInfo', { ns: 'profile' }) as string}</h6>
      <NameForm onSubmit={handleSubmit}>
        <Input
          id="name"
          type="text"
          name="name"
          required={true}
          forwardRef={nameInput}
          placeholder={i18n.t('name', { ns: 'profile' }) as string}
          autoComplete="off"
          defaultValue={userName}
          label={i18n.t('name', { ns: 'profile' }) as string}
        />
        <SubmitName type="submit" color="green" loading={loading}>
          <Icon
            className="right"
            type="save"
            style={{ float: languageDirection() === 'rtl' ? 'right' : 'left' }}
          />
          {i18n.t('save', { ns: 'profile' }) as string}
        </SubmitName>
      </NameForm>
    </Box>
  );
};

export default ChangeName;
